import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/my-coupon-icon.png'
import _imports_1 from '@/assets/img/offer-icon.png'


const _hoisted_1 = { class: "banners-section" }
const _hoisted_2 = { class: "clubcard-card-coupon" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "clubcard-card-coupon-exchanged-image",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "clubcard-card-coupon-exchanged-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "clubcard-card-coupon-center-line" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "clubcard-card-coupon-gift-image",
  src: _imports_1
}, null, -1)
const _hoisted_7 = { class: "clubcard-card-coupon-gift-title" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "side-by-side-wrapper"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "side-banner-content" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 2,
  class: "widget-wrapper"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "widget-banner-content" }
const _hoisted_17 = ["innerHTML"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "clubcard-card-coupon-exchanged-wrapper",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.openModalCouponLotus()))
      }, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.textTitleLotus), 1)
      ]),
      _hoisted_5,
      _createElementVNode("div", {
        class: "clubcard-card-coupon-gift-wrapper",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.openModalCouponBZB()))
      }, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.textTitleLifestyle), 1)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultConfig?.custom_banners, (banner, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "banner-row",
        key: index
      }, [
        (banner.banner_type === 'single-banner')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "banner-image",
              style: _normalizeStyle(_ctx.bannerStyle(banner, { isFull: true})),
              onClick: $event => (_ctx.handleClickBanner(banner))
            }, [
              _createElementVNode("span", {
                style: _normalizeStyle(banner.label?.style)
              }, _toDisplayString(banner.label?.text), 5)
            ], 12, _hoisted_8))
          : (banner.banner_type === 'side-by-side-banner')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(banner.banners, (subBanner, subIndex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    subBanner
                      ? (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["side-banner", {
            'left': subIndex === 0,
            'right': subIndex === 1
          }]),
                          style: _normalizeStyle(_ctx.bannerStyle(subBanner)),
                          onClick: $event => (_ctx.handleClickBanner(subBanner)),
                          key: subIndex
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", {
                              class: "truncate-2-lines",
                              innerHTML: subBanner.label?.text,
                              style: _normalizeStyle(subBanner.label?.style)
                            }, null, 12, _hoisted_12),
                            _createElementVNode("span", {
                              class: "truncate-1-line",
                              style: _normalizeStyle(subBanner.sub_text?.style)
                            }, _toDisplayString(subBanner.sub_text?.text), 5)
                          ])
                        ], 14, _hoisted_10))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]))
            : (banner.banner_type === 'group-widget')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupBanners(banner.banners), (row, rowIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "widget-row",
                      key: rowIndex,
                      style: _normalizeStyle(_ctx.bannerRowStyle(banner))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (groupBanner) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: groupBanner.label.text,
                          class: "widget-banner",
                          style: _normalizeStyle(_ctx.bannerWidgetStyle(groupBanner)),
                          onClick: $event => (_ctx.handleClickBanner(groupBanner))
                        }, [
                          _createElementVNode("img", {
                            src: groupBanner.background_image_url,
                            class: "widget-image"
                          }, null, 8, _hoisted_15),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", {
                              style: _normalizeStyle(groupBanner.label?.style),
                              innerHTML: groupBanner.label?.text
                            }, null, 12, _hoisted_17)
                          ])
                        ], 12, _hoisted_14))
                      }), 128))
                    ], 4))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}